import { AlertPlugin, ConfirmPlugin, PromptPlugin } from './dialog';
import LoadingPlugin from './loading';
import NotifyPlugin from './notify';
import ToastPlugin from './toast';

export { AlertPlugin, ConfirmPlugin, PromptPlugin, LoadingPlugin, NotifyPlugin, ToastPlugin };



// WEBPACK FOOTER //
// ./src/plugins/index.js